module.exports = __webpack_public_path__ + "static/subaru-wrx-sti-s209-white-front-allstocksociety-600px-2c5dc4c3dbac8b01d3bc158d7839c654.jpg";